import React from "react";
import { Input } from "./input";
import { Label } from "./label";
import { cn } from "../../lib/utils";

const FormInput = ({ id, name, label, error, className, ...props }) => {
    return (
        <div className="space-y-2">
            {label && <Label htmlFor={id || name}>{label}</Label>}
            <Input
                id={id || name}
                name={name}
                className={cn(className, error && "border-red-500 text-red-500 focus-visible:ring-red-500/20")}
                {...props}
            />
            {error && <p className="text-xs text-red-500 font-semibold">{error}</p>}
        </div>
    );
};

export default FormInput;

